import { cloneDeep, forEach } from 'lodash';
import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import {
  listingApi,
} from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';

import {
  ONLINEBOOK,
} from './constants';

function* storeOnlineBook(data = {}, merge = true) {
  yield put({
    type: ONLINEBOOK.update,
    data,
    merge,
  });
}

function* fetchOnlineBook({
  data,
}) {
  yield* storeOnlineBook(data);
}

function* updateOnlineBook({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    let id = _id;
    if (_id) {
      const {
        onlineBook,
      } = yield select();
      const updatedData = cloneDeep(onlineBook.data);
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'onlineBook',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      updatedData[_id] = data;
      yield* storeOnlineBook(updatedData);
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'onlineBook',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      id = newData._id;
      yield* storeOnlineBook({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess(id));
  } catch (error) {
    yield* storeOnlineBook();
    errorHandler('Thất bại', error);
  }
}

function* removeOnlineBook({
  _id,
  onSuccess,
}) {
  const {
    onlineBook,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'onlineBook',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(onlineBook.data);
    delete newData[_id];
    yield* storeOnlineBook(newData, false);

    successHandler('Thành công', 'Xóa thành công', onSuccess);
  } catch (error) {
    yield* storeOnlineBook();
    errorHandler('Thất bại', error);
  }
}

function* importOnlineBook({
  data = [],
}) {
  const newDocuments = [];
  const updateDocuments = [];
  data.forEach((doc) => {
    if (doc?.createdAt) {
      updateDocuments.push(doc);
    } else {
      newDocuments.push(doc);
    }
  });

  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'onlineBook',
      payload: {
        data: newDocuments,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));

  if (updateDocuments.length) {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.updates({
        collection: 'onlineBook',
        payload: {
          data: updateDocuments,
        },
      }).then(() => resolve(true))
        .catch((err) => reject(err));
    }));
  }

  const {
    onlineBook,
  } = yield select();
  const newDocs = cloneDeep(onlineBook.data);
  forEach(data,
    (obj) => {
      newDocs[obj._id] = obj;
    });
  yield* storeOnlineBook(newDocs);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* onlineBookSaga() {
  yield all([
    yield takeEvery(ONLINEBOOK.handlers.fetch, fetchOnlineBook),
    yield takeEvery(ONLINEBOOK.handlers.update, updateOnlineBook),
    yield takeEvery(ONLINEBOOK.handlers.import, importOnlineBook),
    yield takeEvery(ONLINEBOOK.handlers.remove, removeOnlineBook),
  ]);
}
